module.exports = __webpack_public_path__ + "4677e529250fc0240d52f1538d2e6ab9.png";